module.exports = __webpack_public_path__ + "img/error.cc0c2102.svg";